import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';

/**
 * Separator component with customizable border styles
 * @param {Object} props - Component props
 * @param {string} props.className - Additional CSS classes to apply
 * @param {string} props.variant - Border variant (default: 'left')
 * @returns {JSX.Element} Separator component
 */
export default function Separator({ className, variant = 'left' }) {
  return (
    <span
      className={twMerge(classNames(
        'mom-border block',
        {
          'border-l-2 h-full mx-2': variant === 'left',
          'border-r-2 h-full mx-2': variant === 'right',
          'border-t-2 h-full my-4': variant === 'top',
          'border-b-2 h-full my-4': variant === 'bottom',
        },
        className
      ))}
    />
  );
}

Separator.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf(['left', 'right', 'top', 'bottom']),
};
